import ReactGA from 'react-ga';

export const InitGA = (trackingID) => {
    ReactGA.initialize(trackingID);
    ReactGA.pageview(window.location.pathname + window.location.search);
}
